var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSortByNameDescending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 16-3 4-3-4h2V4h2v12h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h7v2L7.5 9H12v2H5V9l4.5-5H5V2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.5 13h-2L4 22h2l.77-2h3.46l.77 2h2l-3.5-9Zm-.038 5L8.5 15.5 7.538 18h1.924Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSortByNameDescending);
export default __webpack_public_path__ + "static/media/ic_action_sort_by_name_descending.9fbc5e59e03d8bfbee37e59acc992133.svg";
export { ForwardRef as ReactComponent };